module.exports = __webpack_public_path__ + "static/media/intro.50d9ce41.mp3";